<template>
  <v-menu v-model="menu" :close-on-content-click="false" offset-y>
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-bind="attrs"
        v-on="on"
        type="text"
        v-model="selectedAnimalId"
        :placeholder="$t('select') + ' ' + animalType"
        outlined
        dense
        readonly
        :loading="loading"
        append-icon="mdi-menu-down"
        @click:append="menu = true"
      ></v-text-field>
    </template>
    <v-card>
      <v-toolbar flat class="pt-5 pb-0">
        <v-text-field
          type="text"
          :placeholder="'Search ' + animalType"
          outlined
          dense
          v-model="search"
          @input="getAnimalsWithSearch"
          class="mr-5"
        ></v-text-field>
        <v-spacer></v-spacer>
        <div class="mt-n5">
          <v-btn fab outlined x-small depressed color="primary" @click="page=page-1" :disabled="page==1"><v-icon>mdi-chevron-left</v-icon></v-btn>
          <v-btn fab outlined x-small depressed color="primary" @click="page=page+1" class="mx-2" :disabled="page==totalPages"><v-icon>mdi-chevron-right</v-icon></v-btn>
        </div>
      </v-toolbar>
      <v-card-text class="pt-0">
        <v-checkbox class="py-0" v-model="onlyExisting" :label="'Only ' + animalType"></v-checkbox>
        <div class="text-center" v-if="this.loading">
        <v-progress-circular
          :size="100"
          color="primary"
          indeterminate
          style="margin:auto"
          
        ></v-progress-circular>
        </div>
            
        <v-list-item-group v-else class="px-0">
          <v-list flat style="max-height: 250px" class="overflow-y-auto">
            <template v-for="animal in animalList">
              <v-list-item
                :key="animal.animalNumber"
                @click="selectanimal(animal.animalNumber)"
                :color="animal.animalNumber == value ? 'primary' : ''"
              >
                <v-list-item-avatar>
                  <v-img :alt="`animal avatar`" :src="imageUrl(animal)"></v-img>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>{{
                    `${animal.animalNumber} - ${animal.id}(${animal.name || "N/A"})`
                  }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-list>
        </v-list-item-group>
      </v-card-text>
      <div class="gray2 py-3 primary--text text-center">
        <a
          @click="
            () => {
              $router.push({ name: 'Animals', query: { type: animalType } });
            }
          "
          >View All {{ animalType }}s ({{ this.totalRecords }})
        </a>
      </div>
    </v-card>
  </v-menu>
</template>
<script>
import AnimalService from "@/_services/AnimalService";

export default {
  mounted() {
    (this.selectedAnimalId = this.value), this.getAnimals();
  },
  props: {
    value: {
      required: false,
    },
    animalType: {
      type: String,
      required: true,
    },
    source: {
      type: String,
    },
    currentAnimal: {
      type: String,
    },
  },
  watch: {
    onlyExisting: {
      handler() {
        this.page = 1;
        this.getAnimals()
      }
    },
    value: {
      handler(val) {
        this.selectedAnimalId = val;
      },
      deep: true,
    },
    page: {
      handler() {
        this.getAnimals()
      }
    }
  },
  data() {
    return {
      onlyExisting: false,
      menu: false,
      selectedAnimalId: this.value,
      search: "",
      animalList: [],
      inputField: "",
      loading: false,
      page: 1,
      limit: 20,
      totalPages: 1,
      totalRecords: 0,
    };
  },

  methods: {
    getAnimalsWithSearch() {
      this.page = 1;
      this.getAnimals()
    },
    getAnimals() {
      this.loading = true;
      if(this.source&&this.source=='lgcloud'){
        AnimalService.getAnimals(
        this.animalType,
        {
            page: this.page,
            itemsPerPage: this.limit,
        },
        this.search,
        "lgcloud"
      )
        .then(res => {
          this.animalList = res.data.rows;
          this.totalRecords =  res.data.totalRows;
          this.totalPages = Math.ceil(Number(res.data.totalRows) / this.limit)
          this.loading = false;
        })
        .catch(e => {
          console.log("error", e);
          this.loading = false;
        });
      }else if(this.onlyExisting){
        AnimalService.getAnimals(
        this.animalType,
        {
            page: this.page,
            itemsPerPage: this.limit,
        },
        this.search,
        "lgcomm"
      )
        .then(res => {
          this.animalList = res.data.rows;
          this.totalRecords =  res.data.totalRows;
          this.totalPages = Math.ceil(Number(res.data.totalRows) / this.limit)
          this.loading = false;
        })
        .catch(e => {
          console.log("error", e);
          this.loading = false;
        });
      } else{
        AnimalService.getAnimalWithGender(
        this.animalType.toLowerCase() == "sire" ? "male" : "female",
        {
            page: this.page,
            itemsPerPage: this.limit,
        },
        this.search,
        this.currentAnimal
      )
        .then(res => res.data)
        // .then(data => data.animalList)
        .then(data => {
          this.animalList = data.animalList;
          this.totalRecords =  data.totalRecords;
          this.totalPages = Math.ceil(Number(data.totalRecords) / this.limit)
          this.loading = false;
        })
        .catch(e => {
          console.log("error", e);
          this.loading = false;
        });
      }
    },

    imageUrl(animal) {
      return animal?.img?.url || "/img/no_img.png";
    },
    selectanimal(animalId) {
      this.selectedAnimalId = animalId;
      this.$emit("input", this.selectedAnimalId);
      this.menu = false;
    },
  },
};
</script>
